import React from "react";
import { WorkShiftPlanningMain } from "./WorkShiftPlanningMain";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import { WorkShiftDialogWrapper } from "./WorkShiftDialogWrapper";
import { useVerifyOptionEnabled } from "../../hooks/useAppOption";
import { OptionWorkShiftPlanningEnabled } from "../../models/common/consts";
import { RouteDialogWrapper } from "./RouteDialogWrapper";
import { ColorCodingDialogWrapper } from "./ColorCodingDialogWrapper";
import { RecurrenceAction } from "../../models/common/enums";

export enum WorkShiftPlanningTab {
    Employee = "employees",
    Vehicle = "vehicles",
    Route = "routes",
}

export interface WorkShiftPlanningParams {
    tab: WorkShiftPlanningTab;
}

interface WorkShiftDialogOwnParams {
    tab: WorkShiftPlanningTab;
    id?: string;
    date?: string;
    targetId?: string;
    recurrenceAction?: RecurrenceAction;
}

export type WorkShiftDialogParams = WorkShiftPlanningParams &
    WorkShiftDialogOwnParams;

export const WorkShiftPlanningRouter = ({ match }: RouteComponentProps) => {
    useVerifyOptionEnabled(OptionWorkShiftPlanningEnabled);

    return (
        <>
            <Switch>
                <Route
                    path={`${match.path}/:tab(${WorkShiftPlanningTab.Employee}|${WorkShiftPlanningTab.Vehicle}|${WorkShiftPlanningTab.Route})`}
                    component={WorkShiftPlanningMain}
                />
                <Redirect
                    push
                    to={`${match.path}/${WorkShiftPlanningTab.Employee}`}
                />
            </Switch>
            <Route
                path={`${match.path}/:tab/new/:date?/:targetId?`}
                component={WorkShiftDialogWrapper}
            />
            <Route
                path={`${match.path}/:tab/edit/:id/:recurrenceAction(${RecurrenceAction.OnlyThis}|${RecurrenceAction.AllFuture}|${RecurrenceAction.EntireSeries})?`}
                component={WorkShiftDialogWrapper}
            />
            <Route
                path={`${match.path}/:tab/route/:id`}
                component={RouteDialogWrapper}
            />
            <Route
                path={`${match.path}/:tab/color-coding`}
                component={ColorCodingDialogWrapper}
            />
        </>
    );
};
